import { mediaReels } from "@/mocks/evidence";

export default function MediaSection() {
  return (
    <section id="media" className="w-full bg-background-50">
      <div className="mx-auto w-full max-w-7xl px-4 py-10 md:px-6 md:py-16">
        <div className="flex flex-wrap items-end justify-between gap-4">
          <div className="max-w-2xl">
            <p className="eyebrow text-xs font-semibold text-primary-700">05 / 录音视频</p>
            <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              音视频卷宗 · 逐句转写对照
            </h2>
            <p className="mt-4 text-sm leading-7 text-foreground-600 md:text-[15px]">
              国产黑料录音视频经转写与补音后归档，标出被裁切与被调换的时间段。
            </p>
          </div>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-6 md:grid-cols-3">
          {mediaReels.map((m) => (
            <article
              key={m.id}
              className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-100"
            >
              <div className="relative w-full overflow-hidden">
                <img
                  src={m.img}
                  alt={`国产黑料${m.cat} ${m.title}`}
                  className="h-44 w-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 flex items-center justify-center bg-foreground-950/25">
                  <span className="flex h-14 w-14 items-center justify-center rounded-full bg-background-50/95 text-primary-700 shadow-none transition-transform group-hover:scale-110">
                    <i className="ri-play-fill pl-1 text-xl" />
                  </span>
                </div>
                <span className="absolute bottom-3 right-3 rounded bg-foreground-950/75 px-2 py-0.5 text-xs text-background-50 backdrop-blur-sm">
                  {m.dur}
                </span>
                <span className="absolute left-3 top-3 rounded bg-background-950/40 px-2 py-1 text-xs text-background-50 backdrop-blur-sm">
                  {m.cat}
                </span>
              </div>
              <div className="flex flex-1 flex-col p-5">
                <div className="flex items-center gap-2 text-xs text-foreground-500">
                  <span className="font-medium text-primary-700">{m.id}</span>
                  <span>·</span>
                  <span>{m.date}</span>
                </div>
                <h3 className="mt-2 font-heading text-base font-semibold leading-snug text-foreground-950">
                  {m.title}
                </h3>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}